/**************************************************
 * Nombre:       IngresoCheck
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Checkbox, FormControlLabel, Typography} from "@mui/material";
import {Brightness1} from "@mui/icons-material";
import {useEffect, useState} from "react";


const IngresoCheck = ({
                          props,
                          nombre,
                          dato,
                          Icono = Brightness1,
                          requerido = false,
                          size = 'small',
                          editable = true,
                          setDato
                      }) => {
    const {register, errors, control, watch, setValue, getValues} = props
    const [seleccion, setSeleccion] = useState(true)

    const cambio = (e) => {

        setValue(dato, e)

    }


    useEffect(() => {

        let valor = getValues(dato)
        setSeleccion(valor)

    }, [watch(dato)])
    return (
        <FormControlLabel control={<Checkbox checked={seleccion} onChange={() => cambio(!seleccion)}/>} label={
            <Typography sx={{fontSize: 14, lineHeight: 1.1}}>
                {nombre}
            </Typography>
        }

        />

    )

}
export default IngresoCheck

const opciones = ['Si', 'No']
